import React from 'react'
import { Button, useQuery, useQueryParam, useViewport } from '@chilecompra/react-kit'
import { useNavigate } from 'react-router-dom'
import routes from '../../config/settings/routes'
import { Grid } from './SearchGoodsAndServicesFooter.styles'

/**
 * The SearchGoodsAndServicesFooter's container.
 */
const SearchGoodsAndServicesFooter = () => {
  const navigate = useNavigate()
  const query = useQuery()
  const quoteCode = useQueryParam('quote')

  const handleBack = () => {
    query.set('quote', quoteCode)
    navigate({ pathname: routes.quoteStepTwo, search: query.toString() }, { replace: true })
  }

  const {
    size: { isDownToTiny }
  } = useViewport()

  return (
    <Grid container>
      <Grid item>
        <Button onClick={handleBack} variant="outlined" width={isDownToTiny ? '100%' : undefined}>
          Volver
        </Button>
      </Grid>
    </Grid>
  )
}

export default SearchGoodsAndServicesFooter
